<template>
    <y-icon
        v-if="value"
        v-clipboard:copy="value"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        :icon="icon"
        :prefix="iconPrefix"
        :size="iconSize"
    />
</template>

<script>
    import Vue from 'vue';
    import VueClipboard from 'vue-clipboard2';
    import { YIcon } from '@components/Icon';

    Vue.use(VueClipboard);
    export default {
        name      : 'CopyValue',
        components: {
            YIcon,
        },

        props: {
            /**
             * Value for copy
             */
            value: [String, Number],

            /**
             * Icon
             */
            icon: {
                type   : String,
                default: 'copy',
            },

            /**
             * Prefix of the icon
             * default fas
             */
            iconPrefix: String,

            /**
             * Size of the icon
             */
            iconSize: String,

            /**
             * On copy text
             */
            copiedText: String,

            /**
             * Error text
             */
            errorText: String,
        },

        methods: {
            /**
             * @inheritdoc
             */
            onCopy() {
                this.$toast.success(this.copiedText);
            },

            /**
             * @inheritdoc
             */
            onError() {
                this.$toast.success(this.errorText);
            },
        },
    };
</script>
